export function SaveTemplateVersion(this: any) {
  return {
    saveParams: {
      ...this.template,
      templateContent: {
        ...this.template.templateContent,
        templateName: this.template.templateName,
        versionNo: this.version,
        updatedUser: this.user,
      },
    },
    isSaveAs: true,
  };
}
